<template>
<div class="horizontal grow gallery-container" style="width: 50vw; height: 70vh">
        <div id="info-container">
            <div>
                <p class="section-title">{{ $t('CONTACTINFORMATION') }}</p>
                <div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('FirstName') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="contact.firstName" type="text" :placeholder="$t('FirstName')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Surname') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="contact.lastName" type="text" :placeholder="$t('LastName')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Email') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="contact.email" type="email" :placeholder="$t('Email')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('PhoneNumber') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="contact.phoneNumber" type="text" :placeholder="$t('PhoneNumber')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Description') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="contact.description" type="text" :placeholder="$t('Description')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;">
                                <div :class="['alarm-type-card', { 'selected-alarm-type' : 'SYSTEMS' == selectedMode}]" v-on:click="changeSelection('SYSTEMS')">
                                    <div class="noselect" style="font-weight: bolder; font-size: 12px; word-break: break-word; margin: auto;">{{ $t('Systems') }}</div>
                                </div>
                            </td>
                            <td style="width:200px;" class="info-field-value">
                                <div :class="['alarm-type-card', { 'selected-alarm-type' : 'GROUPS' == selectedMode}]" v-on:click="changeSelection('GROUPS')">
                                    <div class="noselect" style="font-weight: bolder; font-size: 12px; word-break: break-word; margin: auto;">{{ $t('Groups') }}</div>
                                </div>
                            </td>
                        </tr>
                    </div>
                    <div v-if="selectedMode == 'SYSTEMS'" class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Systems') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <div v-for="(sys, index) in access" :key="index">{{ sys.systemName }}</div>
                            </td>
                        </tr>
                    </div>
                    <div v-else-if="selectedMode == 'GROUPS'">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Groups') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="contact.systemsGroup" type="text" :placeholder="$t('SystemGroup')" list="groupsid">
                                <datalist id="groupsid">
                                  <option v-for="g in groups" :key="g.id">
                                    {{g.name}}
                                  </option>
                                </datalist>
                            </td>
                        </tr>
                    </div>
                    <div v-if="error != ''" class="info-field horizontal">
                        <div class="error">{{ error }}</div>
                    </div>
                </div>
            </div>
            <div style="align-self: center;">
                <Button :title="'Save'" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>
        <div id="systems-container">
            <div :class="selectedMode == 'SYSTEMS' ? '' : 'disablegrid'" style="display: flex; flex-direction: column; flex: 1 1 0%; height: calc(100% - 50px); width: 90%; margin: auto; padding: 20px 0 20px 0;">
                <ejs-grid ref="modal_grid" height='100%' width='100%' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="systems" :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :showBusyIndicator="true" :rowSelected="selectionChanged" :rowDeselected="selectionChanged">
                    <e-columns>
                        <e-column type='checkbox' width='50' headerText='Discontinued' textAlign='Left'></e-column>
                        <e-column field='systemName' :headerText="$t('SystemName').toUpperCase()" textAlign='Left'></e-column>
                        <e-column field='country' :headerText="$t('Country').toUpperCase()" textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, GridPlugin } from '@syncfusion/ej2-vue-grids';
import { getSystemFarms, addContact, updateContact, updateContactSystems, getContactById, getSystemsWithCountries, getExistingGroups } from '@/api/api'
import Button from '../Button.vue';
import Select from '../Select'

export default {
    props: {
        contactObj: {
            required: false,
            type: Object
        }
    },
    components: {
        Button,
        Select
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ]
    },
    data() {
        return {
            contact: {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                systems: [],
                description: '',
            },
            systems: [],
            error: "",
            groups: [],

            wrapSettings: { wrapMode: 'Content' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            selectedMode: 'GROUPS'
        }
    },
    computed: {
        access(){
            return this.contact.systems;
        }
    },
    methods: {
        async getContact() {
            this.systems = await getSystemsWithCountries();
            this.groups = await getExistingGroups();

            if(this.contactObj == null)
                return;

            var usr = await getContactById(this.contactObj.id)

            this.contact.id = usr.id;
            this.contact.firstName = usr.firstName;
            this.contact.lastName = usr.lastName;
            this.contact.email = usr.email;
            this.contact.phoneNumber = usr.phoneNumber;
            this.contact.description = usr.description;
            this.contact.systems = [];
            this.contact.systemsGroup = usr.systemsGroup

            var systemsIndex = [];

            this.selectedMode = usr.systemsGroup != '' ? 'GROUPS' : 'SYSTEMS' ;

            for(let i = 0; i < usr.systems.length; i++) {
              var x = this.systems.filter(m => m.id == usr.systems[i].id);

              if(x != null && x.length > 0) {
                this.contact.systems.push(x[0]);

                for(let j = 0; j < this.systems.length; j++){
                    if(this.systems[j].id == x[0].id){
                        systemsIndex.push(j);
                        break;
                    }
                }

              }
            }

            this.$refs.modal_grid.selectRows(systemsIndex);

        },
        selectionChanged() {
            this.contact.systems = [];
            this.contact.systems = this.$refs.modal_grid.getSelectedRecords();
        },
        dataBound: function() {
            this.$refs.modal_grid.autoFitColumns();
        },
        async save() {
            var con = Object.assign({}, this.contact)

            if(this.selectedMode == 'GROUPS'){
                con.systems = []
            } else if(this.selectedMode == 'SYSTEMS') {
                con.systemsGroup = ''
            }

            if (this.contactObj != null){
                updateContact(con)
                    .then((data) => {
                      this.$emit("save");
                    }).catch((error) => {
                        this.processError(error)
                    })
            } else {
                this.error = ''
                addContact(this.contact)
                    .then((newContact) => {
                        this.$emit("save");
                    }).catch((error) => {
                        this.processError(error)
                    })
            }
        },
        changeSelection(mode){
            this.selectedMode = mode

            // if(this.selectedMode == 'SYSTEMS'){
            //     // this.$nextTick(() => )
            //     this.selectSystemRows()
            // }
        },
        selectSystemRows(){
            var systemsIndex = [];

            var usr = Object.assign({}, this.contact)

            for(let i = 0; i < usr.systems.length; i++) {
                var x = this.systems.filter(m => m.id == usr.systems[i].id);

                if(x != null && x.length > 0) {
                    for(let j = 0; j < this.systems.length; j++){
                        if(this.systems[j].id == x[0].id){
                            systemsIndex.push(j);
                            break;
                        }
                    }
                }
            }

            // console.log(systemsIndex)

            systemsIndex.forEach(idx => {
                this.$refs.modal_grid.selectRow(idx, true);
            })

        },
        processError(error){
          if(error.response.data[0] != undefined){
            this.error = error.response.data[0].description
          } else {
            // console.log({err: error.response})
            this.error = ""
            if(error.response.data.errors.Password != undefined) {
              this.error = error.response.data.errors.Password[0]
            } else if (error.response.data.errors.Email != undefined) {
              this.error = error.response.data.errors.Email[0]
            }
          }
        }
    },
    mounted: async function() {
        this.getContact();
    }
}
</script>

<style scoped>

.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    width: 50%;
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

#systems-container {
    width: 50%;
    align-items: center;
    justify-content: center;
    /* margin: auto; */
}

.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

input[type=text], input[type="email"], input[type="password"] {
    border: unset;
    border-bottom: 1px solid #0095b233;
    width: 100%;
}

input[type=text]:focus, input[type="email"]:focus, input[type="password"]:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}

select {
    border: none;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}

.alarm-type-card {
	display: flex;
	align-items: center;
	background-color: rgba(243, 243, 243, 1);
	cursor: pointer;
	padding: 0 12px;
	border: 1px solid rgba(224, 224, 224, 1);
	border-radius: 5px;
	height: 30px;
	margin: 5px 5px;
	box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
	-ms-flex-item-align: center;
	text-align: left;
	background-color: white;
}

.alarm-type-card:hover {
	background-color: rgba(0, 125, 149, 0.1);
	color: black;
}

.selected-alarm-type {
	background-color: rgba(0, 125, 149, 1);
	color: white;
}

.disablegrid {
    pointer-events: none;
    opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Contacts/ContactModal.vue